/* @jsx h */
import { defineComponent, h, computed } from "vue";

function isToday(date: Date): boolean {
  const now = new Date();
  return (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  );
}

function formatDateTime(date: Date): string {
  const time = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  if (isToday(date)) return time;
  const dateStr = date.toLocaleDateString([], {
    month: "short",
    day: "numeric",
  });
  return `${dateStr} · ${time}`;
}

export type DateTimeRendererProps = {
  datetime: string;
  class?: string;
};

export const DateTimeRenderer = defineComponent<DateTimeRendererProps>({
  name: "DateTimeRenderer",
  props: ["datetime", "class"],
  setup(props) {
    const formatted = computed(() => formatDateTime(new Date(props.datetime)));
    return () => (
      <span class={props.class ?? ""}>{formatted.value}</span>
    );
  },
});
